// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { VerifyNewEmailAccountData, VerifyNewEmailAccountResponse, VerifyNewEmailAccountError, DeleteAccountData, DeleteAccountResponse, GetProfileData, GetProfileResponse, UpdateProfileData, UpdateProfileResponse, GetPreferencesData, GetPreferencesResponse, OverwritePreferencesData, OverwritePreferencesResponse, AddPreferencesData, AddPreferencesResponse, DeletePreferencesData, DeletePreferencesResponse, GetBookmarksData, GetBookmarksResponse, AddBookmarkData, AddBookmarkResponse, DeleteBookmarkData, DeleteBookmarkResponse, GetBookmarkData, GetBookmarkResponse, GetBookmarksSimpleData, GetBookmarksSimpleResponse, AddBookmarksSimpleData, AddBookmarksSimpleResponse, GetMyTripsData, GetMyTripsResponse, AddMyTripData, AddMyTripResponse, AddMyTripError2, GetMyTrips2Data, GetMyTrips2Response, DeleteBookingData, DeleteBookingResponse, GetBookingDetailsData, GetBookingDetailsResponse, GetChecklistDataData, GetChecklistDataResponse, AddChecklistItemData, AddChecklistItemResponse, UpdateChecklistItemData, UpdateChecklistItemResponse, GetProfileMyTripsByBookingCodeFlightData, GetProfileMyTripsByBookingCodeFlightResponse, GetGuestCheckInStatusData, GetGuestCheckInStatusResponse, GetPointsData, GetPointsResponse, RegisterClubData, RegisterClubResponse, LeaveClubData, LeaveClubResponse, RedeemCodeData, RedeemCodeResponse, AccessTokenData, AccessTokenResponse, CheckBookingData, CheckBookingResponse2, GetProfileMyTripsByBookingCodeRailData, GetProfileMyTripsByBookingCodeRailResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * verify new email
 */
export const verifyNewEmailAccount = <ThrowOnError extends boolean = false>(options: Options<VerifyNewEmailAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifyNewEmailAccountResponse, VerifyNewEmailAccountError, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/account/verify-email',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const deleteAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteAccountResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/account/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetProfileResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile',
        ...options
    });
};

/**
 * only requested parameters get updated
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateProfileResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * get preferences
 */
export const getPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetPreferencesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPreferencesResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/preferences',
        ...options
    });
};

/**
 * remove old preferences and add new preferences
 */
export const overwritePreferences = <ThrowOnError extends boolean = false>(options?: Options<OverwritePreferencesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<OverwritePreferencesResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * add new preferences to profile
 */
export const addPreferences = <ThrowOnError extends boolean = false>(options?: Options<AddPreferencesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<AddPreferencesResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * remove preferences
 */
export const deletePreferences = <ThrowOnError extends boolean = false>(options: Options<DeletePreferencesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePreferencesResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/preferences/{code}',
        ...options
    });
};

export const getBookmarks = <ThrowOnError extends boolean = false>(options?: Options<GetBookmarksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBookmarksResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark',
        ...options
    });
};

/**
 * add or overwrite bookmark
 */
export const addBookmark = <ThrowOnError extends boolean = false>(options: Options<AddBookmarkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddBookmarkResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * remove bookmark
 */
export const deleteBookmark = <ThrowOnError extends boolean = false>(options: Options<DeleteBookmarkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteBookmarkResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark/{tripCode}',
        ...options
    });
};

/**
 * get bookmark
 */
export const getBookmark = <ThrowOnError extends boolean = false>(options: Options<GetBookmarkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBookmarkResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark/{tripCode}',
        ...options
    });
};

/**
 * get bookmarks without configuration
 */
export const getBookmarksSimple = <ThrowOnError extends boolean = false>(options?: Options<GetBookmarksSimpleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBookmarksSimpleResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark/simple',
        ...options
    });
};

/**
 * add bookmarks without configuration
 */
export const addBookmarksSimple = <ThrowOnError extends boolean = false>(options?: Options<AddBookmarksSimpleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<AddBookmarksSimpleResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/bookmark/simple',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * @deprecated
 * get my trips data. Will be replaced with /profile/my-tripsv2
 */
export const getMyTrips = <ThrowOnError extends boolean = false>(options?: Options<GetMyTripsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyTripsResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips',
        ...options
    });
};

/**
 * add a trip to my bookings
 */
export const addMyTrip = <ThrowOnError extends boolean = false>(options?: Options<AddMyTripData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AddMyTripResponse, AddMyTripError2, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * get my trips data
 */
export const getMyTrips2 = <ThrowOnError extends boolean = false>(options?: Options<GetMyTrips2Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyTrips2Response, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-tripsv2',
        ...options
    });
};

/**
 * remove booking
 */
export const deleteBooking = <ThrowOnError extends boolean = false>(options: Options<DeleteBookingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteBookingResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}',
        ...options
    });
};

/**
 * get booking details. Can also be accessed with custom accessToken => [`POST /profile/access-token`](#AccessToken/accessToken)
 */
export const getBookingDetails = <ThrowOnError extends boolean = false>(options: Options<GetBookingDetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBookingDetailsResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}',
        ...options
    });
};

/**
 * get checklist for booking
 */
export const getChecklistData = <ThrowOnError extends boolean = false>(options: Options<GetChecklistDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChecklistDataResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}/checklist',
        ...options
    });
};

/**
 * add custom checklist item
 */
export const addChecklistItem = <ThrowOnError extends boolean = false>(options: Options<AddChecklistItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddChecklistItemResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}/checklist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * update checklist item
 */
export const updateChecklistItem = <ThrowOnError extends boolean = false>(options: Options<UpdateChecklistItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateChecklistItemResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}/checklist/{code}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get flight details for a booking
 * Retrieve flight details by booking code. Can also be accessed with custom accessToken => [`POST /profile/access-token`](#AccessToken/accessToken)
 */
export const getProfileMyTripsByBookingCodeFlight = <ThrowOnError extends boolean = false>(options: Options<GetProfileMyTripsByBookingCodeFlightData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProfileMyTripsByBookingCodeFlightResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}/flight',
        ...options
    });
};

/**
 * Retrieve guest check-in status for a specific trip. Requires authentication with an API key.
 */
export const getGuestCheckInStatus = <ThrowOnError extends boolean = false>(options: Options<GetGuestCheckInStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGuestCheckInStatusResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/isCheckedIn/{mpi}',
        ...options
    });
};

/**
 * get club points
 */
export const getPoints = <ThrowOnError extends boolean = false>(options?: Options<GetPointsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPointsResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/club/points',
        ...options
    });
};

/**
 * sign up to club
 */
export const registerClub = <ThrowOnError extends boolean = false>(options?: Options<RegisterClubData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RegisterClubResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/club/sign-up',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * sign out of club
 */
export const leaveClub = <ThrowOnError extends boolean = false>(options?: Options<LeaveClubData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LeaveClubResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/club/sign-out',
        ...options
    });
};

/**
 * redeem code for points
 */
export const redeemCode = <ThrowOnError extends boolean = false>(options?: Options<RedeemCodeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RedeemCodeResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/club/redeem-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * get custom access token
 */
export const accessToken = <ThrowOnError extends boolean = false>(options?: Options<AccessTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AccessTokenResponse, unknown, ThrowOnError>({
        url: '/profile/access-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * check booking allows the client to verify if a Booking with the provided data exists.
 * It is currently used for the registration form to validate user input.
 *
 */
export const checkBooking = <ThrowOnError extends boolean = false>(options?: Options<CheckBookingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CheckBookingResponse2, unknown, ThrowOnError>({
        url: '/profile/check-booking',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get rail voucher details for a booking
 * Retrieve rail details by booking code. Can also be accessed with custom accessToken => [`POST /profile/access-token`](#AccessToken/accessToken)
 */
export const getProfileMyTripsByBookingCodeRail = <ThrowOnError extends boolean = false>(options: Options<GetProfileMyTripsByBookingCodeRailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProfileMyTripsByBookingCodeRailResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/profile/my-trips/{bookingCode}/rail',
        ...options
    });
};